import { InvoiceItemsFinancialSummary } from './InvoiceItemsFinancialSummary';

export default InvoiceItemsFinancialSummary;
